import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Modal } from '@mui/material';
import { AiOutlineClose } from 'react-icons/ai';
import { TiWarning } from 'react-icons/ti';

import {
  audioFileExtensions,
  docFileExtensions,
  imageFileExtensions,
  mediaFileExtensions,
  videoFileExtensions,
} from '../../constant/commonData';
import { BaseURL } from '../../config/apiUrl';
import IframeComponent from './IframeComponent';
import { signedDataRoomUrl, signedMediaUrl } from '../../constant/downloadFile';
import classes from './MediaPreviewModal.module.css';
import DocPreview from '../../Component/DocPreview';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  border: 'none',
};

const MediaPreviewModal = ({ visible, setVisible, fileInfo }) => {
  console.log('start', fileInfo);

  const type = fileInfo?.key?.split('.')?.pop()?.toLowerCase();
  const { access_token: accessToken } = useSelector((state) => state.authReducer);
  // SharePoint files open through a short-lived signed link (the file route
  // needs one), so images, PDFs and the Office viewer still load.
  const [signed, setSigned] = useState('');
  useEffect(() => {
    let live = true;
    if (fileInfo?.fileId) signedDataRoomUrl(fileInfo.fileId, accessToken).then((u) => live && setSigned(u || ''));
    // Deal room files kept in S3 need a signed link too; other files open as before.
    else if (fileInfo?.key)
      signedMediaUrl(fileInfo.key, accessToken, !mediaFileExtensions.includes(type)).then((u) => live && setSigned(u || ''));
    return () => {
      live = false;
    };
  }, [fileInfo?.fileId, fileInfo?.key, accessToken]);

  // SharePoint files: one viewer for every file type, Office files sent as
  // PDF by the server (redesign part 4: "the preview must work well").
  if (fileInfo?.fileId)
    return visible ? (
      <DocPreview
        file={{ fileId: fileInfo.fileId, fileName: fileInfo.name || fileInfo.key }}
        token={accessToken}
        onClose={() => setVisible(false)}
        onDownload={async () => {
          const u = signed || (await signedDataRoomUrl(fileInfo.fileId, accessToken));
          if (u) window.location.href = u;
        }}
      />
    ) : null;

  const url = signed;

  return (
    <>
      <div className={classes.closeIcon} onClick={() => setVisible(false)}>
        <AiOutlineClose size={20} />
      </div>
      <Modal
        open={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className={classes.titleContainer}>{fileInfo?.name}</div>
          {imageFileExtensions.includes(type) ? (
            <div className={classes.imageContainer}>
              <img src={url} alt={'Unexpected Error'}></img>
            </div>
          ) : [...videoFileExtensions, ...audioFileExtensions, 'pdf'].includes(
              type,
            ) ? (
            <iframe className={classes.frameContainer} src={url}></iframe>
          ) : ['csv', 'txt'].includes(type) ? (
            <IframeComponent url={url} />
          ) : docFileExtensions.includes(type) ? (
            <iframe
              className={classes.frameContainer}
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
            ></iframe>
          ) : (
            <div className={classes.errorContainer}>
              <TiWarning size={30} />
              <div>Sorry but, we don't support</div>
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default MediaPreviewModal;
